import * as Types from '../constants/actionTypes';

const defaultState = {
  isPending: false,
  eventKeys: [],
  error: ''
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case Types.EVENT_KEYS_SUCCESS: {
      return {
        ...state,
        eventKeys: action.payload
      }
    }

    case Types.EVENT_KEYS_ADDED_SUCCESS: {
      return {
        ...state,
        eventKeys: action.payload
      }
    }

    case Types.EVENT_KEYS_ERROR:
      return {
        ...state,
        eventKeyError: action.eventKeyError
      }

    case Types.EVENT_KEYS_COUNT_SUCCESS:
      return Object.assign({}, state, { eventKeyCount: action.payload })

    case Types.EVENT_KEYS_UPDATE_SUCCESS:
      const updateIndex = state.eventKeys.findIndex((data) => { return data.id === action.payload.id });
      if (updateIndex > -1) {
        state.eventKeys[updateIndex] = action.payload
      }
      return {
        ...state
      }

    case Types.EVENT_KEYS_DELETED_SUCCESS:
      const newList = state.eventKeys.filter((data) => data.id !== action.payload)
      return {
        ...state,
        eventKeys: newList,
        deletedeventKeysStatus: action.payload
      }
    default:
      return state;

  }
};